import { computed } from 'vue';

/**
 * Stub composable for AI integration features.
 * Returns default values and no-op handlers now that the OpenAI integration is removed.
 * @returns {Object} An object containing AI-related stubs.
 */
export function useAI() {
  const draftMessage = computed(() => '');
  const uiFlags = computed(() => ({ isFetching: false }));
  const appIntegrations = computed(() => []);
  const currentChat = computed(() => null);
  const replyMode = computed(() => 'reply');
  const isAIIntegrationEnabled = computed(() => false);
  const isLabelSuggestionFeatureEnabled = computed(() => false);
  const isFetchingAppIntegrations = computed(() => false);

  const fetchIntegrationsIfRequired = async () => {};
  const recordAnalytics = () => {};
  const fetchLabelSuggestions = async () => [];
  const processEvent = async () => '';

  return {
    draftMessage,
    uiFlags,
    appIntegrations,
    currentChat,
    replyMode,
    isAIIntegrationEnabled,
    isLabelSuggestionFeatureEnabled,
    isFetchingAppIntegrations,
    fetchIntegrationsIfRequired,
    recordAnalytics,
    fetchLabelSuggestions,
    processEvent,
  };
}
